import { render, staticRenderFns } from "./TemplateDialogDelete.vue?vue&type=template&id=2471d5ce&scoped=true&"
import script from "./TemplateDialogDelete.vue?vue&type=script&lang=js&"
export * from "./TemplateDialogDelete.vue?vue&type=script&lang=js&"
import style0 from "./TemplateDialogDelete.vue?vue&type=style&index=0&id=2471d5ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2471d5ce",
  null
  
)

export default component.exports